"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTypes = {
    Access: 'access',
    Refresh: 'refresh'
};
